module.exports = "data:image/gif;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvcHJlbG9hZGVyXzAyXzAxLjdhY2Y1YzUwLmdpZiI7"